var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoaded1)?_c('ejs-gantt',{ref:"gantt",attrs:{"id":"GanttContainer","dataSource":_vm.data,"taskFields":_vm.taskFields,"columns":_vm.columns,"height":'100vh',"treeColumnIndex":1,"editSettings":_vm.editSettings,"loadChildOnDemand":false,"toolbar":_vm.toolbar,"taskMode":_vm.taskMode,"allowResizing":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }